import { render, staticRenderFns } from "./ValorTotal.vue?vue&type=template&id=4126ebc2"
import script from "./ValorTotal.vue?vue&type=script&lang=js"
export * from "./ValorTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports